/* eslint-disable */
import { makeAutoObservable, toJS } from 'mobx';
import { configure } from 'mobx';
import moment from 'moment';
import { storage } from '../helpers/storage.js';
import { cell_t, project_t, user_t } from '../logic/types';
import { mainData, mainStore } from './mainStore';
import React from 'react';
import { api } from '../api/index';
import { projectDetailsData, projectDetailsStore } from './projectDetailsStore';
const { v4: uuidv4 } = require('uuid');
configure({ enforceActions: 'never' });

interface link_t {
    link: string;
    style: {
        display: string;
        top?: string;
        left?: string;
    };
}
interface projects_data_t {
    copyNum: number;
    state: 'init' | 'loading' | 'error' | 'success';
    projects: project_t[];
    filteredProjects: project_t[];
    isModalVisible: boolean;
    modalData: string | null;
    link: link_t;
    searchFor: string;
}
class ProjectsStore {
    constructor() {
        makeAutoObservable(this);
    }

    data: projects_data_t = {
        state: 'init',
        projects: [],
        copyNum: 0,
        filteredProjects: [],
        isModalVisible: false,
        modalData: null,
        link: {
            link: '',
            style: { display: 'none' },
        },
        searchFor: window.localStorage.getItem('searchFor') || '',
    };
    hideLink = () => {
        let link = {
            link: '',
            style: {
                top: '0px',
                left: '0px',
                display: 'none',
            },
        };
        return link;
    };

    hideAll = () => {
        let link = this.hideLink();
        this.data.isModalVisible = false;
        this.data.modalData = null;
        this.data.link = link;
    };

    filterProjects = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.data.searchFor = e.target.value.toLowerCase().trim();
        window.localStorage.setItem('searchFor', this.data.searchFor);
        let filteredProjects = JSON.parse(JSON.stringify(this.data.projects));
        filteredProjects = this.data.projects.filter(
            (project: project_t) => project.name && project.name.toLowerCase().indexOf(projectsData.searchFor) >= 0
        );
        this.data.filteredProjects = filteredProjects;
    };

    sortBy = (key: string, order: string, type: number): void => {
        let filteredProjects = JSON.parse(JSON.stringify(this.data.projects));

        if (order === 'asc') {
            filteredProjects.sort((p1: any, p2: any) => {
                if (key === 'creationDate') {
                    return moment(p1[key]).valueOf() - moment(p2[key]).valueOf();
                }
                return p1[key] - p2[key];
            });
        } else {
            filteredProjects.sort((p1: any, p2: any) => {
                if (key === 'creationDate') {
                    return moment(p2[key]).valueOf() - moment(p1[key]).valueOf();
                }
                return p2[key] - p1[key];
            });
        }
        this.data.filteredProjects = filteredProjects;
    };

    duplicateProject = async (id: any) => {
        let filter = projectsData.searchFor.toLowerCase().trim();
        let projects = JSON.parse(JSON.stringify(projectsData.projects));
        let project: project_t = projects.find((proj: project_t) => proj.id == id);
        if (!project.id) return;
        let cells = await api.fetchProjectsCells(project.id);
        let newId = uuidv4();

        let updatedCells = cells.data.cells.Items.map((cell: any) => {
            cell.project_id = newId;
            return cell;
        });
        let duplicatedProject = {
            name: project.name,
            cells: updatedCells,
            type: 'project',
            id: newId,
            creationDate: new Date(),
        };

        if (duplicatedProject.name.includes('copy')) {
            let name = duplicatedProject.name.split('-');
            if (/[0-9]/g.test(name[1])) {
                duplicatedProject.name = `${name[0]}-${name[1].replace(/[0-9]/g, String(this.data.copyNum))}`;
            } else {
                duplicatedProject.name = `${project.name}-(${this.data.copyNum})`;
            }
        } else {
            duplicatedProject.name += '-copy';
            this.data.copyNum = 0;
        }
        this.data.copyNum = this.data.copyNum + 1;

        try {
            let rsp = await api.saveProject(duplicatedProject);
            updatedCells.forEach((cell: cell_t) => api.saveCell(newId, cell));

            projects.unshift(duplicatedProject);
            let filteredProjects = projects.filter((project: project_t) => project.name && project.name.toLowerCase().indexOf(filter) >= 0);
            this.data.projects = projects;
            this.data.filteredProjects = filteredProjects;
        } catch (err) {
            M.toast({ html: 'An error happened. Could not duplicate the project.', classes: 'red' });
        }
    };

    hideModal = () => {
        this.data.isModalVisible = false;
        this.data.modalData = null;
    };

    deleteProject = async (id: string | null) => {
        if (!id) return;
        this.hideModal();

        this.data.searchFor = '';
        let projects = JSON.parse(JSON.stringify(this.data.projects));

        try {
            await api.deleteProject(id);
            let filtered = projects.filter((project: project_t, index: number) => project.id !== id);
            this.data.projects = filtered;
            this.data.filteredProjects = filtered;
            M.toast({ html: 'Project successfully deleted', classes: 'teal lighten-2' });
        } catch (err) {
            M.toast({ html: 'An error happened. Could not delete the project.', classes: 'red' });
        }
    };

    previewLink = (e: React.MouseEvent<HTMLElement, MouseEvent>, url: string) => {
        e.preventDefault();
        e.stopPropagation();
        let link = {
            link: url,
            style: {
                top: e.clientY + 10 + 'px',
                left: e.clientX - 400 + 'px',
                display: 'flex',
            },
        };
        this.data.link = link;
    };
    fetchProjects = async () => {
        this.data.state = 'loading';
        try {
            const {
                data: {
                    data: { projects, user },
                },
            } = await api.fetchProjects();
            mainData.user = user;
            localStorage.setItem('user', JSON.stringify(user));
            //* Some projects were created before introduction to creationDate.
            let sortedProjects = projects.Items.sort(
                (a: any, b: any) => moment(b.creationDate || 1).valueOf() - moment(a.creationDate || 1).valueOf()
            );
            let searchFor = window.localStorage.getItem('searchFor');
            let filteredProjects = sortedProjects;
            if (searchFor) {
                filteredProjects = filteredProjects.filter((project: any) => project.name && project.name.toLowerCase().indexOf(searchFor) >= 0);
            }
            this.data.projects = sortedProjects;
            this.data.filteredProjects = filteredProjects;
            this.data.state = 'success';
        } catch (err: any) {
            if (err.message.includes('401')) window.location.href = 'https://eyesee-hubs.com/login';
            this.data.state = 'error';
            M.toast({ html: 'An error happened. Could not load the projects.', classes: 'red' });
        }
    };
}

export let projectsStore = new ProjectsStore();
export let projectsData = projectsStore.data;
